export class DialogModelCollectAcknowledgementSlip {
    constructor(
        public debitNote: any
    ) {}
  }
  